/* 动画类型选择 */
import React, { CSSProperties, useRef } from 'react';
import { AnimType } from '@tencent/slide-sdk-model';
import Select from '@tencent/dui/lib/components/Select';
import { getAnimIcon } from '../utils';
import { animTypeMap, iconTypeMap, ShapeTypeMap } from '../constants';
import AnimGallery from '@src/framework/frame-pc/components/anim-gallery';
import { ANIMATION_ICON_LIST } from '../../constants';
import { AnimationHistory } from '../../animationHistory';

import Style from '../index.less';


export type AnimTypeSelectProps = {
    animType: AnimType,
    disabled: boolean,
    onModify: (animType: string, categoryId?: string) => void
};

const AnimTypeSelect = (props: AnimTypeSelectProps) => {
    const { animType, disabled, onModify } = props;
    const content = useRef<HTMLElement>();
    const categoryList = AnimationHistory.getInstance().getAllAnimWithHistory();

    const listStyle: CSSProperties = {
        boxSizing: 'content-box',
        maxHeight: '404px',
        padding: 0,
    };

    return (
        <Select
            className={Style['animation-select']}
            selectDomRef={(ref) => {
                if (ref) {
                    content.current = ref;
                }
            }}
            containerDom={content.current}
            listStyle={listStyle}
            dropdownAlignment="right"
            dropdownMatchSelectWidth={false}
            defaultValue={animType}
            destroyOnClose
            disabled={disabled}
            value={animTypeMap[animType] || ShapeTypeMap[animType] || animType}
            renderTag={(tag) => {
                const iconType = iconTypeMap[tag.value] || tag.value;
                const icon = getAnimIcon(iconType as AnimType);

                return (
                    <div className={Style['select-tag']} key={tag.value}>
                        <img src={icon} className={Style['tag-icon']}/>
                        {tag.children}
                    </div>
                );
            }}
            renderDropdown={
                () => <AnimGallery
                    selectedId={iconTypeMap[animType] || ShapeTypeMap[animType] || animType}
                    animCategoryList={categoryList}
                    onClick={onModify}
                />}
        >
            {
            // 需要在选项中加上路径动画，避免导入携带路径动画的 ppt 显示异常
                ANIMATION_ICON_LIST.map((item, index) => {
                    if (animTypeMap[item.id]) {
                        return (
                            <Select.Option key={index} value={animTypeMap[item.id]}>
                                {item.label}
                            </Select.Option>
                        );
                    }
                    return (
                        <Select.Option key={index} value={item.id}>
                            {item.label}
                        </Select.Option>
                    );
                })
            }
        </Select>
    );
};

export default AnimTypeSelect;
